import { Component, OnInit, Input } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../classes/company';
import { Router } from "@angular/router";
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {
  @Input() name: string;
  @Input() transparent: boolean;
  @Input() backgroundColor: string;
  @Input() color: string;
  @Input() orgId: number;
  @Input() companyName: string;
  company: any;
  username: string;
  isAdmin: boolean;

  constructor(private CompanyService: CompanyService, private UserService: UserService, private router: Router) {
  }

  ngOnInit() {
    if (this.orgId) {
      if (this.UserService.currentUser === undefined) {
        this.UserService
          .getUserInfo()
          .subscribe(user => {
            let u: any = JSON.parse(user.user);
            this.username = u.first_name;
            this.isAdmin = u.admin;
            this.getCompanyAsAdmin();
          });
      } else {
        this.username = this.UserService.currentUser.first_name;
        this.isAdmin = this.UserService.currentUser.admin;
        this.getCompanyAsAdmin();
      }
    }
  }

  logOut() {
    this.UserService
      .logOut()
      .subscribe(
      res => { this.router.navigate(['/']) },
      err => { }
      );
  }

  getCompanyAsAdmin() {
    console.log('step1')
    if (this.isAdmin) {
      console.log('step2')
      this.CompanyService
        .getCompany(this.orgId)
        .subscribe(org => {
          this.company = JSON.parse(org.organization);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/top-bar/top-bar.component.ts